import React, { useEffect, useState } from 'react'
import { franchiseService } from '../services/franchise.service'

const formatGb = (gb) => `${Number(gb).toFixed(gb < 10 ? 1 : 0)} GB`
const formatNumber = (n) => new Intl.NumberFormat('pt-BR').format(n)

const barColor = (pct) => {
  if (pct >= 90) return 'bg-red-500'
  if (pct >= 70) return 'bg-amber-500'
  return 'bg-emerald-500'
}

const textColor = (pct) => {
  if (pct >= 90) return 'text-red-600 dark:text-red-400'
  if (pct >= 70) return 'text-amber-600 dark:text-amber-400'
  return 'text-emerald-600 dark:text-emerald-400'
}

const MiniBar = ({ icon, label, valueLabel, percentage }) => (
  <div>
    <div className="flex items-center justify-between text-[11px] mb-0.5">
      <span className="flex items-center gap-1 text-gray-500 dark:text-gray-400">
        <span className="material-icons" style={{ fontSize: 13 }}>{icon}</span>
        {label}
      </span>
      <span className="flex items-center gap-1.5">
        <span className={`font-semibold tabular-nums ${textColor(percentage)}`}>{Math.round(percentage)}%</span>
        <span className="text-gray-400 dark:text-gray-500">{valueLabel}</span>
      </span>
    </div>
    <div className="h-1.5 rounded-full bg-gray-200 dark:bg-gray-700 overflow-hidden">
      <div
        className={`h-full rounded-full ${barColor(percentage)} transition-all duration-500`}
        style={{ width: `${Math.min(Math.max(percentage, 2), 100)}%` }}
      />
    </div>
  </div>
)

/** Bem simples: só o total de armazenamento (banco + arquivos) e eventos do mês, sem detalhamento. */
const FranchiseUsageStrip = ({ apiToken }) => {
  const [usage, setUsage] = useState(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    if (!apiToken) return
    let cancelled = false
    franchiseService.getUsage(apiToken)
      .then((data) => { if (!cancelled) setUsage(data) })
      .catch(() => { if (!cancelled) setFailed(true) })
    return () => { cancelled = true }
  }, [apiToken])

  if (failed || !usage?.database || !usage?.storage || !usage?.events) return null

  const storageUsedGb = usage.database.used_gb + usage.storage.used_gb
  const storagePct = usage.limit_gb ? Math.min((storageUsedGb / usage.limit_gb) * 100, 100) : 0

  return (
    <div className="bg-white/80 dark:bg-gray-800/70 backdrop-blur-sm rounded-2xl border border-white/60 dark:border-white/10 p-2.5 space-y-1.5">
      <MiniBar
        icon="data_usage"
        label="Armazenamento"
        valueLabel={`${formatGb(storageUsedGb)} / ${formatGb(usage.limit_gb)}`}
        percentage={storagePct}
      />
      <MiniBar
        icon="event_repeat"
        label="Eventos no mês"
        valueLabel={`${formatNumber(usage.events.used)} / ${formatNumber(usage.events.limit)}`}
        percentage={usage.events.percentage_used}
      />
    </div>
  )
}

export default FranchiseUsageStrip
